module.exports = __webpack_public_path__ + "static/media/awfxex32_109.817928cf.ico";